import { render, staticRenderFns } from "./IblockElement.vue?vue&type=template&id=31ee66d0&"
import script from "./IblockElement.vue?vue&type=script&lang=js&"
export * from "./IblockElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Local\\OSPanel\\domains\\partner8.local\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ee66d0')) {
      api.createRecord('31ee66d0', component.options)
    } else {
      api.reload('31ee66d0', component.options)
    }
    module.hot.accept("./IblockElement.vue?vue&type=template&id=31ee66d0&", function () {
      api.rerender('31ee66d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IblockElement.vue"
export default component.exports